import { useState, useEffect, useCallback } from "react";
import { useNavigate, Link } from "react-router-dom";
import { 
  Plus, 
  Pencil, 
  Trash2, 
  LogOut, 
  Youtube, 
  Link as LinkIcon,
  FileText,
  X,
  Save,
  Loader2,
  BarChart3,
  Image as ImageIcon,
  ChevronUp,
  ChevronDown
} from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LOGO_URL = "https://customer-assets.emergentagent.com/job_3887c62b-7cac-4b2d-b17d-6e46f80903f9/artifacts/pcgjlywb_Untitled%20design%20%281%29.png";

// List of countries with their codes and flag emojis
const COUNTRIES = [
  { code: "", name: "Select a country", flag: "" },
  { code: "AF", name: "Afghanistan", flag: "🇦🇫" },
  { code: "AL", name: "Albania", flag: "🇦🇱" },
  { code: "DZ", name: "Algeria", flag: "🇩🇿" },
  { code: "AD", name: "Andorra", flag: "🇦🇩" },
  { code: "AO", name: "Angola", flag: "🇦🇴" },
  { code: "AG", name: "Antigua and Barbuda", flag: "🇦🇬" },
  { code: "AR", name: "Argentina", flag: "🇦🇷" },
  { code: "AM", name: "Armenia", flag: "🇦🇲" },
  { code: "AU", name: "Australia", flag: "🇦🇺" },
  { code: "AT", name: "Austria", flag: "🇦🇹" },
  { code: "AZ", name: "Azerbaijan", flag: "🇦🇿" },
  { code: "BS", name: "Bahamas", flag: "🇧🇸" },
  { code: "BH", name: "Bahrain", flag: "🇧🇭" },
  { code: "BD", name: "Bangladesh", flag: "🇧🇩" },
  { code: "BB", name: "Barbados", flag: "🇧🇧" },
  { code: "BY", name: "Belarus", flag: "🇧🇾" },
  { code: "BE", name: "Belgium", flag: "🇧🇪" },
  { code: "BZ", name: "Belize", flag: "🇧🇿" },
  { code: "BJ", name: "Benin", flag: "🇧🇯" },
  { code: "BT", name: "Bhutan", flag: "🇧🇹" },
  { code: "BO", name: "Bolivia", flag: "🇧🇴" },
  { code: "BA", name: "Bosnia and Herzegovina", flag: "🇧🇦" },
  { code: "BW", name: "Botswana", flag: "🇧🇼" },
  { code: "BR", name: "Brazil", flag: "🇧🇷" },
  { code: "BN", name: "Brunei", flag: "🇧🇳" },
  { code: "BG", name: "Bulgaria", flag: "🇧🇬" },
  { code: "BF", name: "Burkina Faso", flag: "🇧🇫" },
  { code: "BI", name: "Burundi", flag: "🇧🇮" },
  { code: "CV", name: "Cabo Verde", flag: "🇨🇻" },
  { code: "KH", name: "Cambodia", flag: "🇰🇭" },
  { code: "CM", name: "Cameroon", flag: "🇨🇲" },
  { code: "CA", name: "Canada", flag: "🇨🇦" },
  { code: "CF", name: "Central African Republic", flag: "🇨🇫" },
  { code: "TD", name: "Chad", flag: "🇹🇩" },
  { code: "CL", name: "Chile", flag: "🇨🇱" },
  { code: "CN", name: "China", flag: "🇨🇳" },
  { code: "CO", name: "Colombia", flag: "🇨🇴" },
  { code: "KM", name: "Comoros", flag: "🇰🇲" },
  { code: "CG", name: "Congo", flag: "🇨🇬" },
  { code: "CD", name: "Congo (DRC)", flag: "🇨🇩" },
  { code: "CR", name: "Costa Rica", flag: "🇨🇷" },
  { code: "CI", name: "Côte d'Ivoire", flag: "🇨🇮" },
  { code: "HR", name: "Croatia", flag: "🇭🇷" },
  { code: "CU", name: "Cuba", flag: "🇨🇺" },
  { code: "CY", name: "Cyprus", flag: "🇨🇾" },
  { code: "CZ", name: "Czech Republic", flag: "🇨🇿" },
  { code: "DK", name: "Denmark", flag: "🇩🇰" },
  { code: "DJ", name: "Djibouti", flag: "🇩🇯" },
  { code: "DM", name: "Dominica", flag: "🇩🇲" },
  { code: "DO", name: "Dominican Republic", flag: "🇩🇴" },
  { code: "EC", name: "Ecuador", flag: "🇪🇨" },
  { code: "EG", name: "Egypt", flag: "🇪🇬" },
  { code: "SV", name: "El Salvador", flag: "🇸🇻" },
  { code: "GQ", name: "Equatorial Guinea", flag: "🇬🇶" },
  { code: "ER", name: "Eritrea", flag: "🇪🇷" },
  { code: "EE", name: "Estonia", flag: "🇪🇪" },
  { code: "SZ", name: "Eswatini", flag: "🇸🇿" },
  { code: "ET", name: "Ethiopia", flag: "🇪🇹" },
  { code: "FJ", name: "Fiji", flag: "🇫🇯" },
  { code: "FI", name: "Finland", flag: "🇫🇮" },
  { code: "FR", name: "France", flag: "🇫🇷" },
  { code: "GA", name: "Gabon", flag: "🇬🇦" },
  { code: "GM", name: "Gambia", flag: "🇬🇲" },
  { code: "GE", name: "Georgia", flag: "🇬🇪" },
  { code: "DE", name: "Germany", flag: "🇩🇪" },
  { code: "GH", name: "Ghana", flag: "🇬🇭" },
  { code: "GR", name: "Greece", flag: "🇬🇷" },
  { code: "GD", name: "Grenada", flag: "🇬🇩" },
  { code: "GT", name: "Guatemala", flag: "🇬🇹" },
  { code: "GN", name: "Guinea", flag: "🇬🇳" },
  { code: "GW", name: "Guinea-Bissau", flag: "🇬🇼" },
  { code: "GY", name: "Guyana", flag: "🇬🇾" },
  { code: "HT", name: "Haiti", flag: "🇭🇹" },
  { code: "HN", name: "Honduras", flag: "🇭🇳" },
  { code: "HK", name: "Hong Kong", flag: "🇭🇰" },
  { code: "HU", name: "Hungary", flag: "🇭🇺" },
  { code: "IS", name: "Iceland", flag: "🇮🇸" },
  { code: "IN", name: "India", flag: "🇮🇳" },
  { code: "ID", name: "Indonesia", flag: "🇮🇩" },
  { code: "IR", name: "Iran", flag: "🇮🇷" },
  { code: "IQ", name: "Iraq", flag: "🇮🇶" },
  { code: "IE", name: "Ireland", flag: "🇮🇪" },
  { code: "IL", name: "Israel", flag: "🇮🇱" },
  { code: "IT", name: "Italy", flag: "🇮🇹" },
  { code: "JM", name: "Jamaica", flag: "🇯🇲" },
  { code: "JP", name: "Japan", flag: "🇯🇵" },
  { code: "JO", name: "Jordan", flag: "🇯🇴" },
  { code: "KZ", name: "Kazakhstan", flag: "🇰🇿" },
  { code: "KE", name: "Kenya", flag: "🇰🇪" },
  { code: "KI", name: "Kiribati", flag: "🇰🇮" },
  { code: "KP", name: "North Korea", flag: "🇰🇵" },
  { code: "KR", name: "South Korea", flag: "🇰🇷" },
  { code: "KW", name: "Kuwait", flag: "🇰🇼" },
  { code: "KG", name: "Kyrgyzstan", flag: "🇰🇬" },
  { code: "LA", name: "Laos", flag: "🇱🇦" },
  { code: "LV", name: "Latvia", flag: "🇱🇻" },
  { code: "LB", name: "Lebanon", flag: "🇱🇧" },
  { code: "LS", name: "Lesotho", flag: "🇱🇸" },
  { code: "LR", name: "Liberia", flag: "🇱🇷" },
  { code: "LY", name: "Libya", flag: "🇱🇾" },
  { code: "LI", name: "Liechtenstein", flag: "🇱🇮" },
  { code: "LT", name: "Lithuania", flag: "🇱🇹" },
  { code: "LU", name: "Luxembourg", flag: "🇱🇺" },
  { code: "MO", name: "Macau", flag: "🇲🇴" },
  { code: "MG", name: "Madagascar", flag: "🇲🇬" },
  { code: "MW", name: "Malawi", flag: "🇲🇼" },
  { code: "MY", name: "Malaysia", flag: "🇲🇾" },
  { code: "MV", name: "Maldives", flag: "🇲🇻" },
  { code: "ML", name: "Mali", flag: "🇲🇱" },
  { code: "MT", name: "Malta", flag: "🇲🇹" },
  { code: "MH", name: "Marshall Islands", flag: "🇲🇭" },
  { code: "MR", name: "Mauritania", flag: "🇲🇷" },
  { code: "MU", name: "Mauritius", flag: "🇲🇺" },
  { code: "MX", name: "Mexico", flag: "🇲🇽" },
  { code: "FM", name: "Micronesia", flag: "🇫🇲" },
  { code: "MD", name: "Moldova", flag: "🇲🇩" },
  { code: "MC", name: "Monaco", flag: "🇲🇨" },
  { code: "MN", name: "Mongolia", flag: "🇲🇳" },
  { code: "ME", name: "Montenegro", flag: "🇲🇪" },
  { code: "MA", name: "Morocco", flag: "🇲🇦" },
  { code: "MZ", name: "Mozambique", flag: "🇲🇿" },
  { code: "MM", name: "Myanmar", flag: "🇲🇲" },
  { code: "NA", name: "Namibia", flag: "🇳🇦" },
  { code: "NR", name: "Nauru", flag: "🇳🇷" },
  { code: "NP", name: "Nepal", flag: "🇳🇵" },
  { code: "NL", name: "Netherlands", flag: "🇳🇱" },
  { code: "NZ", name: "New Zealand", flag: "🇳🇿" },
  { code: "NI", name: "Nicaragua", flag: "🇳🇮" },
  { code: "NE", name: "Niger", flag: "🇳🇪" },
  { code: "NG", name: "Nigeria", flag: "🇳🇬" },
  { code: "MK", name: "North Macedonia", flag: "🇲🇰" },
  { code: "NO", name: "Norway", flag: "🇳🇴" },
  { code: "OM", name: "Oman", flag: "🇴🇲" },
  { code: "PK", name: "Pakistan", flag: "🇵🇰" },
  { code: "PW", name: "Palau", flag: "🇵🇼" },
  { code: "PS", name: "Palestine", flag: "🇵🇸" },
  { code: "PA", name: "Panama", flag: "🇵🇦" },
  { code: "PG", name: "Papua New Guinea", flag: "🇵🇬" },
  { code: "PY", name: "Paraguay", flag: "🇵🇾" },
  { code: "PE", name: "Peru", flag: "🇵🇪" },
  { code: "PH", name: "Philippines", flag: "🇵🇭" },
  { code: "PL", name: "Poland", flag: "🇵🇱" },
  { code: "PT", name: "Portugal", flag: "🇵🇹" },
  { code: "PR", name: "Puerto Rico", flag: "🇵🇷" },
  { code: "QA", name: "Qatar", flag: "🇶🇦" },
  { code: "RO", name: "Romania", flag: "🇷🇴" },
  { code: "RU", name: "Russia", flag: "🇷🇺" },
  { code: "RW", name: "Rwanda", flag: "🇷🇼" },
  { code: "KN", name: "Saint Kitts and Nevis", flag: "🇰🇳" },
  { code: "LC", name: "Saint Lucia", flag: "🇱🇨" },
  { code: "VC", name: "Saint Vincent and the Grenadines", flag: "🇻🇨" },
  { code: "WS", name: "Samoa", flag: "🇼🇸" },
  { code: "SM", name: "San Marino", flag: "🇸🇲" },
  { code: "ST", name: "Sao Tome and Principe", flag: "🇸🇹" },
  { code: "SA", name: "Saudi Arabia", flag: "🇸🇦" },
  { code: "SN", name: "Senegal", flag: "🇸🇳" },
  { code: "RS", name: "Serbia", flag: "🇷🇸" },
  { code: "SC", name: "Seychelles", flag: "🇸🇨" },
  { code: "SL", name: "Sierra Leone", flag: "🇸🇱" },
  { code: "SG", name: "Singapore", flag: "🇸🇬" },
  { code: "SK", name: "Slovakia", flag: "🇸🇰" },
  { code: "SI", name: "Slovenia", flag: "🇸🇮" },
  { code: "SB", name: "Solomon Islands", flag: "🇸🇧" },
  { code: "SO", name: "Somalia", flag: "🇸🇴" },
  { code: "ZA", name: "South Africa", flag: "🇿🇦" },
  { code: "SS", name: "South Sudan", flag: "🇸🇸" },
  { code: "ES", name: "Spain", flag: "🇪🇸" },
  { code: "LK", name: "Sri Lanka", flag: "🇱🇰" },
  { code: "SD", name: "Sudan", flag: "🇸🇩" },
  { code: "SR", name: "Suriname", flag: "🇸🇷" },
  { code: "SE", name: "Sweden", flag: "🇸🇪" },
  { code: "CH", name: "Switzerland", flag: "🇨🇭" },
  { code: "SY", name: "Syria", flag: "🇸🇾" },
  { code: "TW", name: "Taiwan", flag: "🇹🇼" },
  { code: "TJ", name: "Tajikistan", flag: "🇹🇯" },
  { code: "TZ", name: "Tanzania", flag: "🇹🇿" },
  { code: "TH", name: "Thailand", flag: "🇹🇭" },
  { code: "TL", name: "Timor-Leste", flag: "🇹🇱" },
  { code: "TG", name: "Togo", flag: "🇹🇬" },
  { code: "TO", name: "Tonga", flag: "🇹🇴" },
  { code: "TT", name: "Trinidad and Tobago", flag: "🇹🇹" },
  { code: "TN", name: "Tunisia", flag: "🇹🇳" },
  { code: "TR", name: "Turkey", flag: "🇹🇷" },
  { code: "TM", name: "Turkmenistan", flag: "🇹🇲" },
  { code: "TV", name: "Tuvalu", flag: "🇹🇻" },
  { code: "UG", name: "Uganda", flag: "🇺🇬" },
  { code: "UA", name: "Ukraine", flag: "🇺🇦" },
  { code: "AE", name: "United Arab Emirates", flag: "🇦🇪" },
  { code: "GB", name: "United Kingdom", flag: "🇬🇧" },
  { code: "US", name: "United States", flag: "🇺🇸" },
  { code: "UY", name: "Uruguay", flag: "🇺🇾" },
  { code: "UZ", name: "Uzbekistan", flag: "🇺🇿" },
  { code: "VU", name: "Vanuatu", flag: "🇻🇺" },
  { code: "VA", name: "Vatican City", flag: "🇻🇦" },
  { code: "VE", name: "Venezuela", flag: "🇻🇪" },
  { code: "VN", name: "Vietnam", flag: "🇻🇳" },
  { code: "YE", name: "Yemen", flag: "🇾🇪" },
  { code: "ZM", name: "Zambia", flag: "🇿🇲" },
  { code: "ZW", name: "Zimbabwe", flag: "🇿🇼" },
];

const EMPTY_FORM = {
  name: "",
  description: "",
  strap_line: "",
  category: "game",
  country: "",
  image_url: "",
  youtube_urls: [""],
  purchase_url: ""
};

// Session duration: 1 hour in milliseconds
const SESSION_DURATION = 60 * 60 * 1000;

// Check if session is valid
const isSessionValid = () => {
  const loginTime = localStorage.getItem("adminLoginTime");
  if (!loginTime) return false;
  const elapsed = Date.now() - parseInt(loginTime, 10);
  return elapsed < SESSION_DURATION;
};

// Get admin password from storage
const getAdminPassword = () => {
  if (isSessionValid()) {
    return localStorage.getItem("adminPassword");
  }
  // Clear expired session
  localStorage.removeItem("adminPassword");
  localStorage.removeItem("adminLoginTime");
  return null;
};

const DRAFT_KEY = "adminGameDraft";

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const [hasDraft, setHasDraft] = useState(false);

  const adminPassword = getAdminPassword();

  // Check for saved draft on mount
  useEffect(() => {
    const savedDraft = localStorage.getItem(DRAFT_KEY);
    if (savedDraft) {
      setHasDraft(true);
    }
  }, []);

  // Auto-save draft when form data changes (only for new games, not edits)
  useEffect(() => {
    if (modalOpen && !selectedGame) {
      const hasContent = formData.name || formData.description || formData.strap_line || formData.image_url || formData.youtube_url || formData.purchase_url;
      if (hasContent) {
        localStorage.setItem(DRAFT_KEY, JSON.stringify(formData));
        setHasDraft(true);
      }
    }
  }, [formData, modalOpen, selectedGame]);

  const clearDraft = () => {
    localStorage.removeItem(DRAFT_KEY);
    setHasDraft(false);
  };

  useEffect(() => {
    if (!adminPassword) {
      toast.error("Please login first");
      navigate("/admin");
    }
  }, [adminPassword, navigate]);

  const fetchGames = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/games`);
      setGames(response.data);
    } catch (error) {
      console.error("Error fetching games:", error);
      toast.error("Failed to load games");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (adminPassword) {
      fetchGames();
    }
  }, [adminPassword, fetchGames]);

  const handleLogout = () => {
    localStorage.removeItem("adminPassword");
    localStorage.removeItem("adminLoginTime");
    toast.success("Logged out successfully");
    navigate("/admin");
  };

  const openAddModal = () => {
    setSelectedGame(null);
    // Check for saved draft
    const savedDraft = localStorage.getItem(DRAFT_KEY);
    if (savedDraft) {
      try {
        const draft = JSON.parse(savedDraft);
        setFormData(draft);
        toast.info("Draft restored");
      } catch {
        setFormData(EMPTY_FORM);
      }
    } else {
      setFormData(EMPTY_FORM);
    }
    setModalOpen(true);
  };

  const openEditModal = (game) => {
    setSelectedGame(game);
    setFormData({
      name: game.name,
      description: game.description,
      strap_line: game.strap_line || "",
      category: game.category || "game",
      country: game.country || "",
      image_url: game.image_url,
      youtube_urls: game.youtube_urls?.length > 0 ? game.youtube_urls : [""],
      purchase_url: game.purchase_url
    });
    setModalOpen(true);
  };

  const openDeleteDialog = (game) => {
    setSelectedGame(game);
    setDeleteDialogOpen(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleYoutubeUrlChange = (index, value) => {
    setFormData(prev => {
      const newUrls = [...prev.youtube_urls];
      newUrls[index] = value;
      return { ...prev, youtube_urls: newUrls };
    });
  };

  const addYoutubeUrl = () => {
    setFormData(prev => ({
      ...prev,
      youtube_urls: [...prev.youtube_urls, ""]
    }));
  };

  const removeYoutubeUrl = (index) => {
    setFormData(prev => ({
      ...prev,
      youtube_urls: prev.youtube_urls.filter((_, i) => i !== index)
    }));
  };

  const moveYoutubeUrl = (index, direction) => {
    setFormData(prev => {
      const newUrls = [...prev.youtube_urls];
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= newUrls.length) return prev;
      [newUrls[index], newUrls[newIndex]] = [newUrls[newIndex], newUrls[index]];
      return { ...prev, youtube_urls: newUrls };
    });
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      toast.error("Game name is required");
      return false;
    }
    if (!formData.description.trim()) {
      toast.error("Description is required");
      return false;
    }
    if (!formData.image_url.trim()) {
      toast.error("Image is required");
      return false;
    }
    if (!formData.purchase_url.trim()) {
      toast.error("Purchase URL is required");
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      setSaving(true);
      
      if (selectedGame) {
        // Filter out empty YouTube URLs
        const dataToSave = {
          ...formData,
          youtube_urls: formData.youtube_urls.filter(url => url.trim() !== "")
        };

        // Update existing game
        await axios.put(
          `${API}/games/${selectedGame.id}?password=${encodeURIComponent(adminPassword)}`,
          dataToSave
        );
        toast.success("Game updated successfully!");
      } else {
        // Filter out empty YouTube URLs
        const dataToSave = {
          ...formData,
          youtube_urls: formData.youtube_urls.filter(url => url.trim() !== "")
        };

        // Create new game
        await axios.post(
          `${API}/games?password=${encodeURIComponent(adminPassword)}`,
          dataToSave
        );
        toast.success("Game added successfully!");
        clearDraft(); // Clear draft on successful save
      }

      setModalOpen(false);
      fetchGames();
    } catch (error) {
      console.error("Error saving game:", error);
      toast.error(error.response?.data?.detail || "Failed to save game");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!selectedGame) return;

    try {
      await axios.delete(
        `${API}/games/${selectedGame.id}?password=${encodeURIComponent(adminPassword)}`
      );
      toast.success("Game deleted successfully!");
      setDeleteDialogOpen(false);
      fetchGames();
    } catch (error) {
      console.error("Error deleting game:", error);
      toast.error(error.response?.data?.detail || "Failed to delete game");
    }
  };

  if (!adminPassword) {
    return null;
  }

  return (
    <div className="min-h-screen bg-[#FAFAF9]">
      {/* Header */}
      <header className="bg-white border-b border-stone-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center gap-3">
              <img 
                src={LOGO_URL} 
                alt="Logo" 
                className="w-10 h-10 rounded-xl"
              />
              <div>
                <h1 className="font-serif font-bold text-lg text-slate-900">
                  Admin Dashboard
                </h1>
                <p className="text-xs text-slate-500 font-sans">Manage your games</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <Link
                to="/admin/analytics"
                className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#7C3AED]/10 text-[#7C3AED] font-sans text-sm font-medium hover:bg-[#7C3AED]/20 transition-colors"
                data-testid="analytics-link"
              >
                <BarChart3 className="w-4 h-4" />
                Analytics
              </Link>
              <Link
                to="/"
                className="text-slate-600 hover:text-slate-900 font-sans text-sm"
                data-testid="view-site-link"
              >
                View Site
              </Link>
              <Button
                variant="outline"
                onClick={handleLogout}
                className="rounded-full"
                data-testid="logout-btn"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Logout
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        {/* Stats & Actions */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-12">
          <div>
            <h2 className="font-serif font-bold text-3xl text-slate-900 mb-2">
              Games Library
            </h2>
            <p className="font-sans text-slate-600">
              {games.length} game{games.length !== 1 ? "s" : ""} in your collection
            </p>
          </div>
          <Button
            onClick={openAddModal}
            className="bg-[#7C3AED] hover:bg-[#6D28D9] rounded-full px-8 py-6 font-sans font-bold hover:scale-105 active:scale-95 transition-transform shadow-lg shadow-[#7C3AED]/20"
            data-testid="add-game-btn"
          >
            <Plus className="w-5 h-5 mr-2" />
            Add New Game
          </Button>
        </div>

        {/* Games List */}
        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="bg-white rounded-2xl overflow-hidden border border-stone-200">
                <div className="skeleton h-40 w-full" />
                <div className="p-6">
                  <div className="skeleton h-6 w-3/4 mb-2 rounded" />
                  <div className="skeleton h-4 w-full rounded" />
                </div>
              </div>
            ))}
          </div>
        ) : games.length > 0 ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 stagger-children">
            {games.map((game) => (
              <div
                key={game.id}
                className="admin-card bg-white rounded-2xl overflow-hidden border border-stone-200"
                data-testid={`admin-game-${game.id}`}
              >
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={game.image_url}
                    alt={game.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-serif font-bold text-lg text-slate-900 mb-2">
                    {game.name}
                  </h3>
                  <p className="font-sans text-slate-600 text-sm line-clamp-2 mb-4">
                    {game.description}
                  </p>
                  <div className="flex gap-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => openEditModal(game)}
                      className="flex-1 rounded-lg"
                      data-testid={`edit-game-${game.id}`}
                    >
                      <Pencil className="w-4 h-4 mr-2" />
                      Edit
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => openDeleteDialog(game)}
                      className="rounded-lg text-red-600 hover:text-red-700 hover:bg-red-50 border-red-200"
                      data-testid={`delete-game-${game.id}`}
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16 bg-white rounded-3xl border border-stone-200">
            <h3 className="font-serif font-bold text-xl text-slate-900 mb-2">
              No games yet
            </h3>
            <p className="font-sans text-slate-600 mb-6">
              Start by adding your first game to the collection
            </p>
            <Button
              onClick={openAddModal}
              className="bg-[#7C3AED] hover:bg-[#6D28D9] rounded-full px-8"
              data-testid="empty-add-game-btn"
            >
              <Plus className="w-5 h-5 mr-2" />
              Add Your First Game
            </Button>
          </div>
        )}
      </main>

      {/* Add/Edit Modal */}
      <Dialog open={modalOpen} onOpenChange={setModalOpen}>
        <DialogContent className="sm:max-w-xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl">
              {selectedGame ? "Edit Game" : "Add New Game"}
            </DialogTitle>
            <DialogDescription className="font-sans">
              {selectedGame 
                ? "Update the game information below" 
                : "Fill in the details to add a new game to your collection"}
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-5 py-4">
            {/* Category Selection */}
            <div>
              <label className="flex items-center gap-2 text-sm font-sans font-medium text-slate-700 mb-2">
                <FileText className="w-4 h-4" />
                Category
              </label>
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={() => setFormData(prev => ({ ...prev, category: "game" }))}
                  className={`flex-1 py-3 px-4 rounded-xl border-2 font-sans font-medium transition-all ${
                    formData.category === "game"
                      ? "border-[#7C3AED] bg-[#7C3AED]/10 text-[#7C3AED]"
                      : "border-stone-200 text-slate-600 hover:border-slate-300"
                  }`}
                  data-testid="category-game"
                >
                  Games
                </button>
                <button
                  type="button"
                  onClick={() => setFormData(prev => ({ ...prev, category: "crowdfunding" }))}
                  className={`flex-1 py-3 px-4 rounded-xl border-2 font-sans font-medium transition-all ${
                    formData.category === "crowdfunding"
                      ? "border-[#7C3AED] bg-[#7C3AED]/10 text-[#7C3AED]"
                      : "border-stone-200 text-slate-600 hover:border-slate-300"
                  }`}
                  data-testid="category-crowdfunding"
                >
                  Crowdfunding
                </button>
              </div>
            </div>

            {/* Name */}
            <div>
              <label className="flex items-center gap-2 text-sm font-sans font-medium text-slate-700 mb-2">
                <FileText className="w-4 h-4" />
                Game Name
              </label>
              <Input
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter game name"
                className="rounded-xl"
                data-testid="input-name"
              />
            </div>

            {/* Description */}
            <div>
              <label className="flex items-center gap-2 text-sm font-sans font-medium text-slate-700 mb-2">
                <FileText className="w-4 h-4" />
                Description
              </label>
              <Textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                placeholder="Describe your game..."
                rows={3}
                className="rounded-xl resize-none"
                data-testid="input-description"
              />
            </div>

            {/* Strap Line */}
            <div>
              <label className="flex items-center gap-2 text-sm font-sans font-medium text-slate-700 mb-2">
                <FileText className="w-4 h-4" />
                Strap Line <span className="text-slate-400">(short tagline for carousel & cards)</span>
              </label>
              <Input
                name="strap_line"
                value={formData.strap_line}
                onChange={handleInputChange}
                placeholder="e.g., Epic adventures await!"
                className="rounded-xl"
                data-testid="input-strap-line"
                maxLength={100}
              />
              <p className="text-xs text-slate-400 mt-1">Optional - if empty, description will be used</p>
            </div>

            {/* Country */}
            <div>
              <label className="flex items-center gap-2 text-sm font-sans font-medium text-slate-700 mb-2">
                <span className="text-lg">🌍</span>
                Country <span className="text-slate-400">(where the game is based)</span>
              </label>
              <select
                name="country"
                value={formData.country}
                onChange={handleInputChange}
                className="w-full rounded-xl border border-stone-200 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#7C3AED] focus:border-transparent"
                data-testid="input-country"
              >
                {COUNTRIES.map((country) => (
                  <option key={country.code} value={country.code}>
                    {country.flag} {country.name}
                  </option>
                ))}
              </select>
              <p className="text-xs text-slate-400 mt-1">Optional - a flag will appear on the game card</p>
            </div>

            {/* Image Upload */}
            <div>
              <label className="flex items-center gap-2 text-sm font-sans font-medium text-slate-700 mb-2">
                <ImageIcon className="w-4 h-4" />
                Game Image
              </label>
              
              {/* Image URL Input */}
              <Input
                name="image_url"
                value={formData.image_url}
                onChange={handleInputChange}
                placeholder="https://example.com/your-image.jpg"
                className="rounded-xl mb-3"
                data-testid="input-image-url"
              />
              <p className="text-xs text-slate-500 mb-3">
                Use an image hosting service (Imgur, Cloudinary, etc.) for permanent images
              </p>
              
              {/* Image Preview */}
              {formData.image_url && (
                <div className="h-32 w-full rounded-xl overflow-hidden bg-stone-100 border border-stone-200">
                  <img 
                    src={formData.image_url} 
                    alt="Preview" 
                    className="w-full h-full object-cover"
                    onError={(e) => e.target.style.display = 'none'}
                  />
                </div>
              )}
            </div>

            {/* YouTube URLs */}
            <div>
              <label className="flex items-center gap-2 text-sm font-sans font-medium text-slate-700 mb-2">
                <Youtube className="w-4 h-4" />
                YouTube Videos <span className="text-slate-400">(optional)</span>
              </label>
              <div className="space-y-2">
                {formData.youtube_urls.map((url, index) => (
                  <div key={index} className="flex gap-2 items-center">
                    <div className="flex flex-col gap-1">
                      <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        onClick={() => moveYoutubeUrl(index, -1)}
                        disabled={index === 0}
                        className="h-5 w-5 p-0"
                      >
                        <ChevronUp className="w-4 h-4" />
                      </Button>
                      <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        onClick={() => moveYoutubeUrl(index, 1)}
                        disabled={index === formData.youtube_urls.length - 1}
                        className="h-5 w-5 p-0"
                      >
                        <ChevronDown className="w-4 h-4" />
                      </Button>
                    </div>
                    <Input
                      value={url}
                      onChange={(e) => handleYoutubeUrlChange(index, e.target.value)}
                      placeholder="https://youtube.com/watch?v=..."
                      className="rounded-xl flex-1"
                      data-testid={`input-youtube-${index}`}
                    />
                    {formData.youtube_urls.length > 1 && (
                      <Button
                        type="button"
                        variant="outline"
                        size="icon"
                        onClick={() => removeYoutubeUrl(index)}
                        className="rounded-xl shrink-0"
                      >
                        <X className="w-4 h-4" />
                      </Button>
                    )}
                  </div>
                ))}
              </div>
              <Button
                type="button"
                variant="ghost"
                onClick={addYoutubeUrl}
                className="mt-2 text-[#7C3AED] hover:text-[#6D28D9] text-sm"
              >
                + Add another video
              </Button>
            </div>

            {/* Purchase URL */}
            <div>
              <label className="flex items-center gap-2 text-sm font-sans font-medium text-slate-700 mb-2">
                <LinkIcon className="w-4 h-4" />
                Purchase URL
              </label>
              <Input
                name="purchase_url"
                value={formData.purchase_url}
                onChange={handleInputChange}
                placeholder="https://store.example.com/game"
                className="rounded-xl"
                data-testid="input-purchase"
              />
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            {!selectedGame && hasDraft && (
              <Button
                variant="ghost"
                onClick={() => {
                  clearDraft();
                  setFormData(EMPTY_FORM);
                  toast.success("Draft cleared");
                }}
                className="rounded-xl text-slate-500 hover:text-slate-700"
                data-testid="clear-draft-btn"
              >
                Clear Draft
              </Button>
            )}
            <Button
              variant="outline"
              onClick={() => setModalOpen(false)}
              className="flex-1 rounded-xl"
              data-testid="cancel-btn"
            >
              <X className="w-4 h-4 mr-2" />
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              disabled={saving}
              className="flex-1 bg-[#7C3AED] hover:bg-[#6D28D9] rounded-xl"
              data-testid="save-btn"
            >
              {saving ? (
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <Save className="w-4 h-4 mr-2" />
              )}
              {saving ? "Saving..." : "Save Game"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <AlertDialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle className="font-serif">Delete Game?</AlertDialogTitle>
            <AlertDialogDescription className="font-sans">
              Are you sure you want to delete "{selectedGame?.name}"? This action cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="rounded-xl" data-testid="cancel-delete-btn">
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={handleDelete}
              className="bg-red-600 hover:bg-red-700 rounded-xl"
              data-testid="confirm-delete-btn"
            >
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
